/* 
fiky-web
*/

import React from "react";

import CommonSection from "../components/UI/common-section/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import "../styles/cart-page.css";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import { cartActions } from "../store/shopping-cart/cartSlice";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <Helmet title="Contact">
      <CommonSection title="Al-Muhayyat Food Contact" />
    </Helmet>
  );
};

export default Contact;
